import { AppShell } from '@mantine/core'
import { PageProps } from 'gatsby'
import { CSSProperties, FC } from 'react'
import { Notifications } from '@mantine/notifications'
import TopBar from './TopBar'
import * as classes from './selfEnrollmentLayout.module.css'
import { useOrganizationTheme } from '../../hooks/organizations'

const SelfEnrollmentLayout: FC<PageProps> = ({ children, location }) => {
  const orgDisplayName = location.pathname.replace(`/enroll/`, ``).split(`/`)[0]

  const orgColorTheme = useOrganizationTheme(orgDisplayName)

  return (
    <AppShell
      padding="md"
      navbar={{ width: 140, breakpoint: 0, collapsed: { mobile: false } }}
      header={{ height: 52 }}
      style={
        {
          '--mantine-primary-color-filled': orgColorTheme.main,
          '--mantine-primary-color-filled-hover': `color-mix(in srgb, ${orgColorTheme.main} 85%, black)`,
          '--mantine-primary-color-contrast': orgColorTheme.contrast,
        } as CSSProperties
      }
    >
      <AppShell.Main className={classes.mainContainer}>
        <TopBar orgDisplayName={orgDisplayName} />
        {children}
      </AppShell.Main>
      <Notifications position="bottom-right" />
    </AppShell>
  )
}

export default SelfEnrollmentLayout
